import {Component, RefObject, createRef} from "react";
import {IProductMedia} from "../product-page";

export default class LazyImage extends Component<{availableSoon: boolean; changeThumbnail?: (index: number) => void; index: number, productMedia: IProductMedia}, any> {
    // Create an intersection observer to lazy load the full image
    private blurredImgRef: RefObject<HTMLImageElement> = createRef();
    private fullImgRef: RefObject<HTMLImageElement> = createRef();
    private readonly imgIsCached: boolean = false;

    state = {
        intersected: false,
        loaded: false
    }

    private checkImageIsCached = (src: string) => {
        const image = document.createElement("img");
        image.src = src;
        return image.complete || image.naturalHeight !== 0 || image.naturalWidth !== 0;
    }

    constructor(props: any) {
        super(props);

        if (this.checkImageIsCached(this.props.productMedia.src)) {
            this.state.intersected = true;
            this.state.loaded = true;
            this.imgIsCached = true;
        }
    }

    componentDidMount() {
        if (!this.imgIsCached) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.setState({intersected: true});
                        this.props.changeThumbnail?.(this.props.index);
                        const fullImg = this.fullImgRef.current!;
                        fullImg.src = fullImg.getAttribute('data-src')!;
                        fullImg.onload = () => {
                            this.setState({loaded: true})
                        };
                    }
                });
            }, {
                root: null,
                rootMargin: '0px',
                threshold: 0.3
            });

            observer.observe(this.blurredImgRef.current!);
        }
    }

    render() {
        return(
            <div className={'picture'} data-intersected={this.state.intersected} style={{aspectRatio: this.props.productMedia.aspectRatio}}>
                <span className={'scroll-anchor'} data-media-index={this.props.index}></span>
                <div className={'animatable-pop-in'}>
                    {this.props.availableSoon &&
                        <div className={'available-soon-overlay'}>
                            {window.currLanguage === 'fr' ? 'Bientôt disponible' : 'Coming soon'}
                        </div>
                    }
                    <img ref={this.blurredImgRef} className={'blurred-image'} src={this.props.productMedia.previewSrc} alt={this.props.productMedia.alt}/>
                    <div className={'loader-container'}>
                        <div className="loader-line"/>
                    </div>
                    {!this.imgIsCached ?
                        <img ref={this.fullImgRef} className={'full-image'} data-src={this.props.productMedia.src} data-loaded={this.state.loaded} alt={this.props.productMedia.alt}/> :
                        <img ref={this.fullImgRef} className={'full-image'} src={this.props.productMedia.src} data-loaded={this.state.loaded} alt={this.props.productMedia.alt}/>
                    }
                </div>
            </div>
        )
    }
}